import { render, staticRenderFns } from "./week_schedule.vue?vue&type=template&id=53a3d6fd&scoped=true"
import script from "./week_schedule.vue?vue&type=script&lang=js"
export * from "./week_schedule.vue?vue&type=script&lang=js"
import style0 from "./week_schedule.vue?vue&type=style&index=0&id=53a3d6fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a3d6fd",
  null
  
)

export default component.exports